import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

import BedType from 'src/comps/BedType'
import BoardCode from 'client/components/Rooms/BoardCode'
import Capacity from 'src/comps/Capacity'

import {
  BoardWrapper,
  Holder,
  HolderInformation,
  Label,
  LabelBold,
  RoomCardBase,
  RoomDescription,
  Row,
  Value,
} from './styles'
import messages from './messages'
import MobileOnlyPrice from 'src/comps/MobileOnlyPrice'

const RoomCard = ({
  adults,
  beds,
  boardCode,
  boardName,
  children,
  childrenAges,
  holders,
  isMobile = false,
  roomName,
  rooms,
}) => (
  <RoomCardBase>
    <RoomDescription>
      <Label>
        <FormattedMessage {...messages.room} />:
      </Label>

      {rooms > 1 && <Value>{`(x${rooms})`}</Value>}
      <Value>{roomName}</Value>
    </RoomDescription>

    <Row>
      <Capacity adults={adults} children={children} childrenAges={childrenAges} />
    </Row>

    <Row>
      <BedType beds={beds} />
    </Row>

    <HolderInformation>
      <LabelBold>
        <FormattedMessage {...messages.holder} />:
      </LabelBold>

      {holders.map((holder, index) => {
        if (index < holders.length - 1) {
          return <Holder key={`holder-${holder.name}`}>{`${holder.name}, `}</Holder>
        }
        return <Holder key={`holder-${holder.name}`}>{holder.name}</Holder>
      })}
    </HolderInformation>

    <BoardWrapper>
      <BoardCode name={boardName} code={boardCode} />
    </BoardWrapper>
    <MobileOnlyPrice isMobileRate={isMobile} />
  </RoomCardBase>
)

RoomCard.propTypes = {
  adults: PropTypes.number,
  boardCode: PropTypes.string,
  boardName: PropTypes.string,
  children: PropTypes.number,
  childrenAges: PropTypes.string,
  holders: PropTypes.arrayOf(PropTypes.shape({ name: PropTypes.string })),
  isMobile: PropTypes.bool,
  roomName: PropTypes.string,
  rooms: PropTypes.number,
  beds: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string,
      description: PropTypes.string,
      quantity: PropTypes.number,
    })
  ),
}

export default RoomCard
